var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCchatAssistantIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.9,
    d: "M16 2.75C8.68 2.75 2.75 8.47 2.75 15.52c0 2.84.96 5.47 2.6 7.6L3.8 29.25l6.5-1.94c1.73.81 3.66 1.26 5.7 1.26 7.32 0 13.25-5.72 13.25-12.77S23.32 2.75 16 2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M11 12.1c.13-2.86 2.17-4.7 5-4.7s4.87 1.84 5 4.7M10.4 12.7c3.29-1.42 7.36-1.75 11.2-.45"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M10.8 13.1c2.15-.65 8.25-.65 10.4 0 1.24.38 1.6 1.86 1.6 4.02 0 2.15-.36 3.62-1.6 4.01-2.15.66-8.25.66-10.4 0-1.24-.39-1.6-1.86-1.6-4.01 0-2.16.36-3.64 1.6-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M9.1 14.2H8c-.7 0-1 .61-1 1.45v2.94c0 .84.3 1.45 1 1.45h1.1M22.9 14.2H24c.7 0 1 .61 1 1.45v2.94c0 .84-.3 1.45-1 1.45h-1.1M7.65 14.2v-2.65M24.35 14.2v-2.65"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.7,
    d: "M12.1 17.45c.35-1.37 1.85-1.37 2.2 0M17.7 17.45c.35-1.37 1.85-1.37 2.2 0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCchatAssistantIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cchat-assistant-icon.69772865.svg";
export { ForwardRef as ReactComponent };